import { Point } from "../Point";

export class SelectBoundary{
    private _p1: Point;
    private _p2: Point;
    private _p3: Point;
    private _p4: Point;
    type: string;
    color: number[];

    get p1():Point {
        return this._p1;
    }
    set p1(point:Point) {
        this._p1 = point;
    }
    get p2():Point {
        return this._p2;
    }
    set p2(point:Point) {
        this._p2 = point;
    }
    get p3():Point {
        return this._p3;
    }
    set p3(point:Point) {
        this._p3 = point;
    }
    get p4():Point {
        return this._p4;
    }
    set p4(point:Point) {
        this._p4 = point;
    }

    
    constructor(p1:Point, p2:Point, p3:Point, p4:Point) {
        this.type = 'selectBoundary';
        this._p1 = p1.clone();
        this._p2 = p2.clone();
        this._p3 = p3.clone();
        this._p4 = p4.clone();
        this.color = [0.75,0.75,0.75,1];
    }

    getVertices() {
        return new Float32Array([
            this.p1.x, this.p1.y,
            this.p2.x, this.p2.y,
            this.p3.x, this.p3.y,
            this.p4.x, this.p4.y
        ])
    }
    getVerticesArray() {
        return [
            this.p1.x, this.p1.y,
            this.p2.x, this.p2.y,
            this.p3.x, this.p3.y,
            this.p4.x, this.p4.y
        ];
    }
}